module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"local-admin:checkbox-lable":"Права пользовательского администратора"},"en":{"local-admin:checkbox-lable":"User administration rights"}}')
  delete Component.options._Ctor
}
